function correct(text) {
  return text.replace(/'/g, '').replace(/’/g, '').replace(/–/g, '-').replace(/–/g, '-').replace(/[\ ]{2,}/g, ' ').replace(/\n/g, '').replace(/(\&shy;|­|&#173;)/gi, '');
}
function correctNote(text) {
  return text.replace(/'/g, '').replace(/’/g, '').replace(/–/g, '-');
}

function footnoteFormatter(footnote) {
  let mynode = footnote.cloneNode(true);
  const triangle = mynode.querySelector('.ns-style-triangle'),
    square = mynode.querySelector('.ns-style-square'),
    hook = mynode.querySelector('.ns-style-hook'),
    diamond = mynode.querySelector('.ns-style-diamond');
  if (triangle)
    triangle.innerHTML = '▲';

  if (square)
    square.innerHTML = '◼';

  if (diamond)
    diamond.innerHTML = '◆';

  if (hook)
    hook.innerHTML = '✓';

  let content = mynode.innerText.trim();

  return content.replace('\n', ' ');

}

const fontBold = {
  bold: true,
  color: {
    argb: 'FF000000'
  }
}

const borderThin = {
  style: 'thin',
  color: {
    argb: 'FF000000'
  }
}

const borderMedium = {
  style: 'medium',
  color: {
    argb: 'FF000000'
  }
}

const xdownloaderConfig = {
  tableTitle: null,
  tableSelector: ".lc-table-wrap",
  excludeTableSelector: '',
  downloadText: "XLS", // Text for downloadbutton, can be empty if you want to use an icon
  footnoteFormatter: footnoteFormatter,
  styles: [
    {
      class: 'head',
      font: fontBold,
      head: true,
      index: 10
    },
    {
      class: 'head_pdf',
      font: fontBold,
      head: true,
      index: 10
    },
    {
      class: 'line_bold',
      font: fontBold,
    },
    {
      class: 'ns-horizontal-left',
      border: {
        bottom: borderThin,
      },
    },
    {
      class: 'ns-horizontal-center',
      border: {
        bottom: borderThin,
      },
    },
    {
      class: 'ns-horizontal-right',
      border: {
        bottom: borderThin,
      },
    },
    {
      class: 'bline_bold',
      font: fontBold,
      border: {
        bottom: borderMedium,
      },
    },
    {
      class: 'line_ind',
      border: {
        bottom: borderThin,
      },
    },
    {
      class: 'noline_bottom',
      border: {
        bottom: null,
      },
    },
    {
      class: 'noline_bold',
      font: fontBold,
      border: {
        bottom: null,
      }
    },
    {
      class: 'noline_bottom_space',
      border: {
        bottom: null,
      }
    },
  ], // cell Styles from classes
  // numFmt, // numFmt overwrite for custom formatting
  // mergeStrings, // Set mergeStrings for all Tables
  tableCellFormatter: function (td) {
    let cellIndex = Array.from(
      td.parentElement.children
    ).indexOf(td);

    let content = "";
    let cell = document.createElement('td');
    cell.innerHTML = td.innerHTML;


    const triangle = cell.querySelector('.triangle'),
      square = cell.querySelector('.square'),
      diamond = cell.querySelector('.diamond'),
      hook = cell.querySelector('.hook');

    if (triangle)
      triangle.innerHTML = '▲';

    if (square)
      square.innerHTML = '◼';

    if (diamond)
      diamond.innerHTML = '◆';

    if (hook)
      hook.innerHTML = '✓';

    let superscript = cell.querySelector('.superscript');
    let superscriptContent = '';
    if (superscript) {
      superscriptContent = '(' + superscript.innerText.replace(/\)/g, '').replace(/\(/g, '') + ')';
      superscript.parentNode.removeChild(superscript);
    }
    if (td.querySelector('.note__link')) {
      content = correctNote(cell.innerText.trim() + ' ' + superscriptContent);
    } else {
      content = correct(cell.innerText.trim() + ' ' + superscriptContent);

      if (square || triangle || diamond) {
        content = content.replace(/\n/g, '').replace(/\ /g, '').trim();
      }
    }

    if (cellIndex == 0 && td.classList.contains('line_ind') && content.trim() != '') {
      // console.log(td)
      content = '   ' + content;
    }

    return content;
  },
};


export default xdownloaderConfig;
